import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface APIState {
    isExecuting: boolean,
    Action : "GET" | "POST" | "PUT" | "DELETE" | undefined,
    URL?: string
    StatusCode: number
    history?:any
  }
  
const initialState:APIState = {
    isExecuting:false,
    Action:undefined,
    URL:"",
    StatusCode:0,
}

export const APISlice = createSlice({
    name:"API",
    initialState,
    reducers:{
        startAPI: (state,action) => {
            state.isExecuting = true;
            state.Action = action.payload.Action;
            state.URL = action.payload.URL;
        },
        EndAPI: (state,action) => {
            state.history.push({Action:action.payload.Action,URL:action.payload.URL,StatusCode:action.payload.StatusCode})
            state.isExecuting = false;
            state.Action = undefined;
            state.URL = "";
            state.StatusCode = 0;
        }
    }
})

export const {startAPI,EndAPI} = APISlice.actions

export const selectAuth = (state: RootState) => state.auth

export default APISlice.reducer;